import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
import moment from "moment";
import { CsvDownload } from '@/types/APIResponse';
import { toCamel } from 'snake-camel';
import { HarvestRecordItem } from '@/types/Component';
import HarvestRecordModal from '@/assets/common/Modal/HarvestRecordModal/HarvestRecordModal.vue'
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import HarvestDetailModal from '@/assets/common/Modal/HarvestDetailModal/HarvestDetailModal.vue';
import PlantingModal from '@/assets/common/Modal/PlantingModal/PlantingModal.vue';
import ShippingRecordModal from '@/assets/common/Modal/ShippingRecordModal/ShippingRecordModal.vue';
import { LoginUser , ShippingRecordHarvestRecord} from "@/types/Component";

@Component({
    components: {
        EmptyGraphMessage,
        HarvestDetailModal,
        HarvestRecordModal,
        ShippingRecordModal,
        PlantingModal
    }
})

export default class HarvestList extends Vue {
   
    screen = 'HARVESTLIST';
    baseUrl = '/harvest_list';
    harvestList =  [] as any[];
    private totalHarvestQuantity : string | null = null;
    private totalShippingQuantity : string | null = null;
    private totalRemainingQuantity : string | null = null;
    selectScreenManagement = '/graphScreenManagement';
    selectedCropOrPlantingId : string | null = null;
    selectedPlantingOrCropName = "";
    private selectedAgriFieldId : string | null = null;
    private selectedAgriFieldName = "";
    private measurementTimingsName :any = "";
    private selectedMeasurementTimingId :string | null = null;
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    private selectedPlantingsOrCrops = 0;
    private lastSetOption = false;
    private agriFields = [] as any[];
    private plantings = [];
    private crops = [];
    private measurementTimings = [] as any[];
    private plantingsOrCrops = [] as any[];
    private images: File[] = []
    private isFilePopUp = false
    private isSpinnerLoading = false;
    private sortOrder = true;
    private showHarvestDetailModal = false;
    private selectedHarvestId :any ='';
    private mode = '';
    private isShow = false
    private isShippingShow = false
    private isRefresh = false;
    private isHarvestOpen = ""
    private isButtonDisabled = false
    private harvestDate: string | null = null
    selectedPlantingId :string | null = null
    private isPlantingShow = false
    selectedShippingId :string | null = null
    private harvestRecordToShippingModel: ShippingRecordHarvestRecord[] = []
    harvestRecord: HarvestRecordItem | null = null
    includeHiddenFlag = false;

    created() {
        this.routeparams(this.$route);
        this.isSpinnerLoading = true
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.getHarvestList()
        this.getAgriFields()
        this.getPlantings()
        this.getCrops()
        this.getMeasurementTiming()
    }

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    routeparams(params:any){
        this.isHarvestOpen =params.query.isHarvestPopup
        this.selectedHarvestId = params?.query?.recordId
        this.harvestDate = params?.query?.date
        if(this.isHarvestOpen || this.selectedHarvestId){
            if(this.isHarvestOpen ==="true" && this.selectedHarvestId == null){
                this.openHarvestPopUpModal( null, 'add')
            }
            else if(this.isHarvestOpen ==="true" && this.selectedHarvestId != null){
                this.openHarvestPopUpModal(this.selectedHarvestId, 'edit')
            }
        }
    }

    getHarvestList() {
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
            this.totalHarvestQuantity = res.harvestListDetails.some((r: { harvestListQualityObjs: any[]; }) => r.harvestListQualityObjs.some(o => o.quantity === '単位未設定')) ? '単位未設定' : res.harvestListDetails.reduce((acc: any, r: { harvestListQualityObjs: any[]; }) => acc + r.harvestListQualityObjs.reduce((acc, o) => o.quantity === '単位未設定' || (o.totalFlag && o.totalFlag === true) ? acc : acc + (o.quantity !== null ? parseFloat(o.quantity.replace(/,/g, '').replace('単位未設定', '0')) : 0), 0), 0);
            this.totalShippingQuantity = res.harvestListDetails.some((r: { harvestListQualityObjs: any[]; }) => r.harvestListQualityObjs.some(o => o.shippedQuantity === '単位未設定')) ? '単位未設定' : res.harvestListDetails.reduce((acc: any, r: { harvestListQualityObjs: any[]; }) => acc + r.harvestListQualityObjs.reduce((acc, o) => o.shippedQuantity === '単位未設定' || (o.totalFlag && o.totalFlag === true) ? acc : acc + (o.shippedQuantity !== null ? parseFloat(o.shippedQuantity.replace(/,/g, '').replace('単位未設定', '0')) : 0), 0), 0);
            this.totalRemainingQuantity = res.harvestListDetails.some((r: { harvestListQualityObjs: any[]; }) => r.harvestListQualityObjs.some(o => o.remainingQuantity === '単位未設定')) 
                ? '単位未設定' 
                : res.harvestListDetails.some((r: { harvestListQualityObjs: any[]; }) => r.harvestListQualityObjs.some(o => o.remainingQuantity === null)) 
                ? null 
                : res.harvestListDetails.reduce((acc: any, r: { harvestListQualityObjs: any[]; }) => acc + r.harvestListQualityObjs.reduce((acc, o) => o.remainingQuantity !== null ? acc + (o.remainingQuantity === '単位未設定' || (o.totalFlag && o.totalFlag === true) ? 0 : parseFloat(o.remainingQuantity.replace(/,/g, '').replace('単位未設定', '0'))) : acc, 0), 0);
            this.harvestList = res.harvestListDetails
            if (res.harvestListDetailsFilterValues) {
                this.plantingsOrCrops = res.harvestListDetailsFilterValues.cropId || this.lastSetOption ? this.crops : this.plantings
                this.selectedPlantingsOrCrops = res.harvestListDetailsFilterValues.cropId || this.lastSetOption ? 1 : 0;
                this.selectedCropOrPlantingId = res.harvestListDetailsFilterValues.cropId ? res.harvestListDetailsFilterValues.cropId : res.harvestListDetailsFilterValues.plantingId
                this.selectedAgriFieldId = res.harvestListDetailsFilterValues.agriFieldId
                this.selectedMeasurementTimingId = res.harvestListDetailsFilterValues.measurementTimingId
                this.includeHiddenFlag = res.harvestListDetailsFilterValues.includeHiddenFlag
            }
            this.selectedStartDate = res.harvestListDetailsFilterValues?.displayFromDate ? res.harvestListDetailsFilterValues.displayFromDate : this.selectedStartDate
            this.selectedEndDate = res.harvestListDetailsFilterValues?.displayToDate ? res.harvestListDetailsFilterValues.displayToDate : this.selectedEndDate
            this.startDate = res.harvestListDetailsFilterValues?.displayFromDate ? res.harvestListDetailsFilterValues.displayFromDate : this.selectedStartDate
            this.endDate = res.harvestListDetailsFilterValues?.displayToDate ? res.harvestListDetailsFilterValues.displayToDate : this.selectedEndDate
            this.isSpinnerLoading = false;
            if (this.selectedStartDate > this.selectedEndDate) {
                this.isButtonDisabled = true;
              }else{
                this.isButtonDisabled = false;
              } 
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
            this.isSpinnerLoading = false;
        })
    }

    getAgriFields() {
        this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
            this.agriFields = res.agri_fields
        });
    }

    getPlantings() {
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
            this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        });
    }

    getCrops() {
        this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
        this.crops = res.crops;
        this.crops.sort((a:any, b:any) => a.name.localeCompare(b.name));
        this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.selectedPlantingOrCropName= this.plantingsOrCrops.find(item=>item.id==this.selectedCropOrPlantingId)?.name
            this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    getMeasurementTiming() {
        this.$apiClient.doRequest('get', '/measurement_timings?with_hidden=true').then(res => {
            this.measurementTimings = res.measurement_timings
            this.measurementTimingsName = res.measurement_timings.find((item:any)=>item.id==this.selectedMeasurementTimingId)?.name 
        })
    }

    openHarvestPopUpModal(id = null, mode = '') {
        this.selectedHarvestId = id;
        this.mode = mode;
        this.isShow = true;
    }

    closeHarvestModal() {
        this.selectedHarvestId = null;
        this.mode = ''
        this.isShow = false;
    }
    
    refreshTable () {
        this.harvestList = []
        this.totalHarvestQuantity = null
        this.totalShippingQuantity = null
        this.totalRemainingQuantity = null
        this.isSpinnerLoading = true
        this.getHarvestList();
    }

    private convertTime(time: number): string {
        if (time % 60 === 0) {
            return Math.floor(time / 60) + "時間";
        } else if(time > 60) {
            return Math.floor(time / 60) + "時間" + Math.floor(time % 60) + "分";
        } else {
            return time + "分";
        }
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ? 
        numberToFormat.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
        }) 
        : '';
    }

    harvestLotNumberSplit(lotNumber: number | string): string[] {
        if (!lotNumber) {
          return [""]; 
        }
        const splitLotNumber = lotNumber.toString().split('、');
        return splitLotNumber;
    }

    private changeDateFormat(inputDate: string): string {
        const newDateFormat= moment(inputDate).format('YYYY/MM/DD')
        return newDateFormat;
    }

    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '---';
    }

    private processData(workersInfo: string): string[] {
        const responses: string[] = [];
        if (workersInfo == null) {
            return responses;
        }
        try {
            const workersArray = JSON.parse(workersInfo);
            if (!Array.isArray(workersArray) || workersArray.length === 0) {
                return responses;
            }
            workersArray.forEach((worker: { [key: string]: number }, index: number) => {
                const name = Object.keys(worker)[0];
                const time = this.minuteToHour(worker[name]);
                responses.push(`${name} : ${time}`);
            });
        } catch (error) {
            // Handle the error if needed
        }
        return responses;
    }

    removeDecimalZeros(number :number) {
        let str = number.toString();
        if (str.includes('.')) {
            str = str.replace(/0+$/, ''); 
            str = str.replace(/\.$/, ''); 
        }
        return str;
    }

    handleSelectChange(flag = true) {
        this.selectedPlantingOrCropName = this.plantingsOrCrops.find(item=>item.id == this.selectedCropOrPlantingId)?.name
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id == this.selectedAgriFieldId)?.name
        this.measurementTimingsName = this.measurementTimings.find((item:any)=>item.id == this.selectedMeasurementTimingId)?.name
        const params = {
            cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            plantingId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            agriFieldId: this.selectedAgriFieldId,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            screenName: this.screen,
            measurementTimingId: this.selectedMeasurementTimingId,
            includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`, params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
            this.isSpinnerLoading = false;
        })
    } 
    
    handlePlantingsCropSelect () {
        this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        this.selectedCropOrPlantingId = null
        this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
        this.handleSelectChange();
    }
    
    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
            this.selectedStartDate = this.startDate;
            this.selectedEndDate = this.endDate;
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
        }
    }

    getHarvestFile(harvestRecordId:string){
        this.$apiClient.doRequest('get', '/harvest_records/' +harvestRecordId ).then(ret => {
            const item = toCamel(ret) as HarvestRecordItem
            if(item.fileId.length > 0) {
                const promise: any = []
                item.fileId.forEach((id: string) => {
                    promise.push(this.$apiClient.doRequest('get', `/harvest_records/${harvestRecordId}/images/${id}`))
                })
                Promise.all(promise).then(ret => {
                    const file = toCamel(ret) as File[]
                    this.images = file
                    this.isFilePopUp =true;
                })
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    closeModalPopup(){
        this.isFilePopUp =false;
    } 

   async exportCsv() {
        this.$apiClient.getRequest( `${this.baseUrl}/csv_export?start_date=${this.selectedStartDate}&end_date=${this.selectedEndDate}&crop_or_planting=${this.selectedPlantingOrCropName?this.selectedPlantingOrCropName:""}&agri_field_name=${this.selectedAgriFieldName?this.selectedAgriFieldName:""}&measurement_timing_name=${this.measurementTimingsName?this.measurementTimingsName:""}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        })
    }
    
    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled == false){
            const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
            const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
            const offset = (action === 'previous') ? -daysDifference : daysDifference;
            this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
            this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
            this.handleSelectChange();
        } else {
            this.isButtonDisabled = false
        }
    } 

    sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.harvestList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    sortObj(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.harvestList.sort((a, b) => {
            const aValue = this.getFirstPossibleValue(a, fieldName);
            const bValue = this.getFirstPossibleValue(b, fieldName);
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    getFirstPossibleValue(obj: { [x: string]: any }, fieldName: string): any {
        const objValues = obj.harvestListQualityObjs.map((obj: { [x: string]: any; }) => obj[fieldName]);
        for (const value of objValues) {
            if (value !== null && value !== undefined && value != "単位未設定") {
                return (fieldName == "quantity" || fieldName == "shippedQuantity" || fieldName == "remainingQuantity") ? parseFloat(value.replace(/,/g, '')) : value;
            }
        }
        return null;
    }    
    
    openHarvestDetailModal(id : string) {
        this.selectedHarvestId = id;
        this.showHarvestDetailModal = true;
    }

    closeHarvestDetailModal() {
        this.selectedHarvestId = null;
        this.showHarvestDetailModal = false;
    }

    openPlantingModal(id = null) {
        this.selectedPlantingId = id;
        this.isPlantingShow = true;
    }

    closePlantingModal() {
        this.selectedPlantingId = null;
        this.isPlantingShow = false;
    }

   async openShippingPopUpModal(id = null,harvestId : any, mode = '') {
       await this.$apiClient.doRequest('get', '/harvest_records/' + harvestId).then(ret => {
            this.harvestRecord = toCamel((ret)) as HarvestRecordItem;
        });
        if (id == null && mode == 'new' && harvestId && this.harvestRecord) {
            const data: ShippingRecordHarvestRecord = {
                id: harvestId,
                harvestDate: this.harvestRecord?.harvestDate,
                measurementTimingId: this.harvestRecord.measurementTimingId,
                planting: {
                    id: this.harvestRecord.planting.id,
                    name: this.harvestRecord.planting.name,
                },
                agriField: {
                    id: this.harvestRecord.agriField.id,
                    name: this.harvestRecord.agriField.name,
                },
                qualityData:''
            };
            this.harvestRecordToShippingModel.push(data);
        }
        this.selectedShippingId = id;
        this.mode = mode;
        this.isShippingShow = true;
    }

    closeShippingModal() {
        this.selectedShippingId = null;
        this.mode = ''
        this.harvestRecordToShippingModel = [];
        this.isShippingShow = false;
    }

    formLabel(arr: any[], key: string): string {
        let result = '';
        arr.forEach(item => {
            if (item[key] !== undefined) {
                const val = (key == "quantity" || key == "shippedQuantity" || key == "remainingQuantity") ? item[key] == "単位未設定" ? `<span style="color: red;" class="tooltip">単位未設定</span>` : (key == "shippedQuantity" && this.isAdmin ? `<a class="edit-link">${item[key] ?? "---"}</a>` : `<span>${item[key] ?? "---"}</span>`) : this.formString(item[key], key);
                result += `${item['totalFlag'] ? `(${val||'---'})` : val || '---'}\n`;
            } else {
                result += '\n';
            }
        });
        return result;
    }

    formString(str: string, key: string): string {
        if (str === null) {
            return "---";
        }
        const length = key == "qualityStandardName" ? 10 : 20;
        return str.length > length ? str.substring(0, length-3) + "..." : str;
    }

    get filterAgriFields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }  
    
    get filterMeasurementTimings() {
        return this.includeHiddenFlag ? this.measurementTimings : this.measurementTimings.filter(mt => this.selectedMeasurementTimingId == mt.id || !mt.is_hidden);
    } 

    get filterPlantingsOrCrops() {
        if (this.selectedPlantingsOrCrops) {
            return this.plantingsOrCrops
        } else {
            return this.includeHiddenFlag ? this.plantingsOrCrops : this.plantingsOrCrops.filter(p => this.selectedCropOrPlantingId == p.id || !p.is_hidden);
        }
    }
}